import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from '../../../app.constants';
import { map } from 'rxjs/operators';
import { Location } from '../model/location';
import { LocationSearchRequest } from '../model/location-search-request.model';
import { createRequestOption } from '../../model/request-util';
import { LocationRequest } from '../model/location-request.model';
import { EnableLoadingIndicator, EnableSavingIndicator } from '../../loading-indicator';

@Injectable()
export class WorkbenchLocationService {

    constructor(private http: HttpClient) {
    }

    getLocationById(locationId: string): Observable<Location> {
        return this.http.get<Location>(SERVER_API_URL + `locations/${locationId}`,
            { observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true) }).pipe(map((res: HttpResponse<Location>) => res.body));
    }

    searchLocations(request: LocationSearchRequest, pagination: any, cropName?: string): Observable<HttpResponse<Location[]>> {

        const params = createRequestOption(pagination);
        const url = SERVER_API_URL + 'locations/search';
        return this.http.post<Location[]>(url, request, { params, observe: 'response', context: new HttpContext().set(EnableLoadingIndicator, true) });
    }

    createLocation(locationRequest: LocationRequest): Observable<Location> {
        const url = SERVER_API_URL + 'locations';
        return this.http.post(url, locationRequest, { observe: 'body', context: new HttpContext().set(EnableSavingIndicator, true) });
    }

    updateLocation(locationRequest: LocationRequest, locationId: number) {
        const url = SERVER_API_URL + `locations/${locationId}`;
        return this.http.put(url, locationRequest, { context: new HttpContext().set(EnableSavingIndicator, true) });

    }

    deleteLocation(locationId: number) {
        const url = SERVER_API_URL + `locations/${locationId}`;
        return this.http.delete(url, { context: new HttpContext().set(EnableSavingIndicator, true) });
    }

}
